import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import CardView from '../CardView/CardView';
import LoadCursore from '../common/LoadCursore';


const CardPage = (props) => {
  return <React.Fragment>
    {/* <LoadCursore /> */}
    <CardView {...props} />
  </React.Fragment>
}

export default CardPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/CardPageView.js